import React from 'react';

function ReplenishmentUnitDiscrepancyDetailCell({ row }) {
    const expectedPalletIDs = row?.expectedResults
        ?.map((result) => result?.expectedPalletID)
        .filter((id) => id !== null);
    const itemName = row?.expectedResults?.[0]?.itemName;
    const lotID = row?.expectedResults?.[0]?.expectedLotID;

    return (
        <div key={row?.expectedResultID} style={{ margin: '10px 0px' }}>
            <div>
                <strong>Item: </strong>
                {itemName}
            </div>
            <div>
                <strong>Lot: </strong>
                {lotID}
                <strong> Sku: </strong>
                {row?.externalSku}
            </div>
            {expectedPalletIDs.length > 0 && (
                <div>
                    <strong>Pallets: </strong>
                    {expectedPalletIDs.join(', ')}
                </div>
            )}
            <div>
                <strong>Expected: </strong>
                {row?.totalExpectedUnits?.toLocaleString()} units ({row?.expectedCaseCount?.toLocaleString()} cases,{' '}
                {row?.expectedLooseUnitCount?.toLocaleString()} loose units)
            </div>
            <div>
                <strong>Actual: </strong>
                {row?.totalActualUnits?.toLocaleString()} units ({row?.actualCaseCount?.toLocaleString()} cases,{' '}
                {row?.actualLooseUnitCount?.toLocaleString()} loose units)
            </div>
            <div>
                <strong>Proposed Adjustment: </strong> {row?.totalUnitDifference > 0 ? '+' : ''}
                {row?.totalUnitDifference?.toLocaleString()} units
            </div>
            <div />

            <div>
                <div style={{ textDecoration: 'underline', textAlign: 'center', fontWeight: 'bold' }}>
                    <strong>Location Details: </strong>
                </div>
                <ul>
                    {row?.expectedResults?.map((result) => (
                        <li key={result?.expectedResultID}>
                            <div>
                                {result?.locationName}:{' '}
                                <span>
                                    {result?.actualCaseCount} cases, {result?.actualLooseUnitCount} loose units
                                </span>
                                {result?.expectedPalletID && <span> on pallet {result?.expectedPalletID}</span>}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export { ReplenishmentUnitDiscrepancyDetailCell };
